/* ── SSA Brand Colors: Royal Blue & White ── */
export const BRAND = {
  primary: "#1d4ed8",      // royal blue (blue-700)
  primaryDark: "#1e40af",   // darker blue (blue-800)
  primaryLight: "#eff6ff",  // blue-50
  accent: "#1e3a8a",        // deep royal (blue-900)
  accentLight: "#2563eb",   // blue-600
};

export const PLAYER_COLORS = [
  "#2563eb","#16a34a","#d97706","#7c3aed",
  "#db2777","#0891b2","#ea580c","#4f46e5","#0d9488",
  "#be123c","#65a30d","#0284c7","#c026d3","#f97316",
];

export const SSA_LOGO = "/logo.webp";
